export default __webpack_public_path__ + "static/media/luniu_logo.235e51c1.png";